import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform, inject } from "@angular/core";

@Pipe({
  name: "time",
  standalone: true,
})
export class TimePipe implements PipeTransform {
  readonly datePipe = inject(DatePipe);

  transform(value: Date | string | number): string | null {
    if (!value) {
      return null;
    }

    const formattedDate = this.datePipe.transform(
      value,
      "yyyy.MM.dd",
      undefined,
      "ko"
    );

    const hour = new Date(value).getHours();
    const minute = new Date(value).getMinutes();
    const ampm = hour < 12 ? "오전" : "오후";
    const formattedTime = `${ampm} ${hour % 12 || 12}:${minute
      .toString()
      .padStart(2, "0")}`;

    return `${formattedDate} ${formattedTime}`;
  }
}
